import React from 'react';

const Pluralise = ({ number, noun, whenZero }) => {
    if (number === 0 && whenZero) return whenZero;
    return <>{number} {noun}{number !== 1 && 's'}</>;
};

export { default as Price } from './Price';
export { default as BookNow } from './BookNow';
export { Pluralise };